import {FC, useState} from 'react'
import { classUtils as c } from 'Vendor/Utils/ClassUtils'

type PreviewImageProps = {
    src?: string
    alt: string
    fallbackIcon?: string
}

// Large preview image with a loading spinner and an icon fallback for missing thumbnails or formats the
// browser cannot display (PDF cards, documents). Keyed by src so each item starts its own load.
const PreviewImage: FC<PreviewImageProps> = ({src, alt, fallbackIcon = 'fa-regular fa-file-image'}) => {
    const [loadedSrc, setLoadedSrc] = useState<string|undefined>(undefined)
    const [failedSrc, setFailedSrc] = useState<string|undefined>(undefined)

    if (!src || failedSrc === src) {
        return <i className={c('no-thumbnail', fallbackIcon)}></i>
    }

    return <>
        {loadedSrc !== src && <i className="fa-solid fa-circle-notch fa-spin"></i>}
        <img key={src}
             src={src}
             alt={alt}
             className={c(loadedSrc !== src && 'd-none')}
             onLoad={() => setLoadedSrc(src)}
             onError={() => setFailedSrc(src)}
        />
    </>
}

export default PreviewImage
